// SEO Data Configuration for Dynamic Landing Pages
// All cities and services are defined here for centralized management

// Contenuti specifici per Sesto San Giovanni - Cluster SEO ottimizzato
const sestoSanGiovanniContent = {
  "web-designer": {
    heroTitle: "Web Designer a",
    heroHighlight: "sistemi digitali su misura",
    heroSubtitle: "Cerchi un web designer a Sesto San Giovanni? Siamo sviluppatori di sistemi digitali completi: non solo siti, ma web app, CRM personalizzati, gestionali e automazioni che trasformano il modo in cui lavori.",
    metaTitleTemplate: "Web Designer Sesto San Giovanni | M&M Web Designers",
    metaDescTemplate: "Cerchi un web designer a Sesto San Giovanni? Realizziamo siti web, web app e soluzioni digitali su misura. Consulenza gratuita, preventivo in 24h.",
    problems: [
      "Perdi tempo con processi manuali che potrebbero essere automatizzati?",
      "I tuoi strumenti digitali non comunicano tra loro?",
      "Vorresti un sistema su misura ma non sai da dove iniziare?",
      "Cerchi un partner tecnologico, non un semplice fornitore di siti?"
    ],
    solutions: [
      { title: "Analisi dei processi", desc: "Mappiamo i tuoi flussi di lavoro per identificare dove l'automazione genera valore" },
      { title: "Ecosistema integrato", desc: "Siti, CRM, gestionali e automazioni che comunicano tra loro" },
      { title: "Sviluppo su misura", desc: "Software costruito sulle tue esigenze, non adattamenti di template" },
      { title: "Evoluzione continua", desc: "Il sistema cresce con la tua azienda, aggiungendo moduli quando servono" }
    ],
    services: [
      "Sviluppo sistemi digitali integrati",
      "Web app e gestionali personalizzati",
      "Automazioni e integrazioni API",
      "CRM su misura per il tuo business"
    ],
    targetAudience: [
      { title: "PMI in crescita", desc: "Aziende pronte a digitalizzare i processi interni" },
      { title: "Professionisti evoluti", desc: "Studi che vogliono automatizzare la gestione clienti" },
      { title: "Imprenditori visionari", desc: "Chi cerca un vantaggio competitivo attraverso la tecnologia" },
      { title: "Attività locali ambiziose", desc: "Chi vuole scalare senza moltiplicare il lavoro manuale" }
    ],
    results: [
      { title: "Processi automatizzati", desc: "Meno lavoro manuale, più tempo per ciò che conta" },
      { title: "Dati centralizzati", desc: "Un unico sistema per clienti, ordini, fatturazione" },
      { title: "Scalabilità reale", desc: "Cresci senza dover raddoppiare il personale" },
      { title: "ROI misurabile", desc: "Ogni automazione si ripaga in ore risparmiate" }
    ],
    faqs: [
      {
        q: "Cosa intendete per 'sistema digitale' rispetto a un semplice sito?",
        a: "Un sito web è una vetrina. Un sistema digitale è un ecosistema: il sito si integra con un CRM per gestire i contatti, un gestionale per ordini e fatturazione, automazioni per follow-up e reminder. Tutto comunica, tutto è su misura per il tuo business."
      },
      {
        q: "Posso incontrarvi di persona a Sesto San Giovanni?",
        a: "Assolutamente sì. Operiamo a Sesto San Giovanni e nell'area di Milano Nord. Per progetti complessi come CRM e gestionali, preferiamo incontrarci di persona per capire a fondo i tuoi processi aziendali."
      },
      {
        q: "Quanto costa sviluppare un sistema digitale su misura?",
        a: "Dipende dalla complessità. Si parte da soluzioni modulari (sito + CRM base) per poi espandere. La prima consulenza è gratuita: analizziamo insieme cosa ti serve davvero e costruiamo un preventivo trasparente, senza sorprese."
      },
      {
        q: "Posso partire con un sito semplice e aggiungere funzionalità dopo?",
        a: "Certamente, è l'approccio che consigliamo. Progettiamo sempre con la scalabilità in mente: oggi il sito, domani l'integrazione CRM, poi le automazioni. Ogni pezzo si incastra in un ecosistema coerente."
      }
    ],
    ctaText: "Progettiamo il tuo sistema",
    ctaSubtext: "Raccontaci come lavori oggi. Ti mostreremo come potrebbe funzionare domani.",
    internalLinks: [
      { url: "/realizzazione-siti-web-sesto-san-giovanni", text: "realizzazione di siti web" },
      { url: "/sviluppo-siti-web-professionali-sesto-san-giovanni", text: "sviluppo professionale" },
      { url: "/siti-web-responsive-seo-sesto-san-giovanni", text: "siti ottimizzati SEO" },
      { url: "/creazione-siti-web-aziende-sesto-san-giovanni", text: "soluzioni per aziende" }
    ]
  },
  "realizzazione-siti-web": {
    heroTitle: "Realizzazione siti web a",
    heroHighlight: "che portano clienti",
    heroSubtitle: "Vuoi un sito web che funziona davvero? Realizziamo siti pensati per farti trovare su Google e trasformare i visitatori in contatti reali. Niente fronzoli, solo risultati.",
    metaTitleTemplate: "Realizzazione Siti Web Sesto San Giovanni | Siti che Convertono",
    metaDescTemplate: "Realizziamo siti web a Sesto San Giovanni orientati ai risultati. Siti vetrina, e-commerce, landing page. Preventivo gratuito in 24h.",
    problems: [
      "Hai bisogno di un sito web ma non sai da dove iniziare?",
      "Il tuo sito attuale non ti porta contatti?",
      "Hai paura di spendere soldi per qualcosa che non funziona?",
      "Vuoi capire esattamente cosa stai pagando?"
    ],
    solutions: [
      { title: "Siti orientati alla conversione", desc: "Ogni elemento è pensato per portarti contatti" },
      { title: "Processo trasparente", desc: "Sai sempre a che punto siamo e cosa stiamo facendo" },
      { title: "Preventivi chiari", desc: "Nessun costo nascosto, sai esattamente cosa paghi" },
      { title: "Tempi rapidi", desc: "Il tuo sito online in 2-3 settimane" }
    ],
    services: [
      "Siti web vetrina per attività locali",
      "Landing page per campagne marketing",
      "E-commerce per vendita online",
      "Siti web per professionisti"
    ],
    targetAudience: [
      { title: "Nuove attività", desc: "Chi sta aprendo e ha bisogno di presenza online" },
      { title: "Attività senza sito", desc: "Chi vuole finalmente farsi trovare su Google" },
      { title: "Chi vuole rifare il sito", desc: "Siti datati che non funzionano più" },
      { title: "Chi lancia un prodotto", desc: "Landing page per promozioni e lanci" }
    ],
    results: [
      { title: "Sito online velocemente", desc: "In 2-3 settimane sei operativo" },
      { title: "Visibilità su Google", desc: "SEO base inclusa in ogni progetto" },
      { title: "Autonomia di gestione", desc: "Modifichi i contenuti in autonomia" },
      { title: "Supporto post-lancio", desc: "Non ti lasciamo solo dopo la pubblicazione" }
    ],
    faqs: [
      {
        q: "Quanto costa realizzare un sito web?",
        a: "Un sito vetrina professionale parte da 800-1.500€. Un e-commerce da 2.000€. Una landing page da 400€. Il prezzo finale dipende dalle funzionalità specifiche. Ti forniamo sempre un preventivo dettagliato prima di iniziare."
      },
      {
        q: "Cosa include il prezzo del sito?",
        a: "Design personalizzato, sviluppo responsive, ottimizzazione SEO base, configurazione hosting, formazione per la gestione autonoma e 30 giorni di supporto post-lancio. Nessun costo nascosto."
      },
      {
        q: "Quanto tempo serve per realizzare un sito?",
        a: "Un sito vetrina richiede 2-3 settimane. Un e-commerce 4-6 settimane. Una landing page 1 settimana. I tempi dipendono anche dalla rapidità con cui ci fornisci i contenuti."
      },
      {
        q: "Devo fornire io testi e immagini?",
        a: "Idealmente sì, perché conosci la tua attività meglio di chiunque. Ma possiamo aiutarti nella stesura dei testi e nella selezione delle immagini se necessario, con un piccolo supplemento."
      }
    ],
    ctaText: "Richiedi un preventivo gratuito",
    ctaSubtext: "Descrivi il tuo progetto, ti rispondiamo in 24 ore con un preventivo dettagliato.",
    internalLinks: [
      { url: "/web-designer-sesto-san-giovanni", text: "il nostro team di web designer" },
      { url: "/sviluppo-siti-web-professionali-sesto-san-giovanni", text: "sviluppo con tecnologie professionali" },
      { url: "/siti-web-responsive-seo-sesto-san-giovanni", text: "ottimizzazione SEO e mobile" },
      { url: "/creazione-siti-web-aziende-sesto-san-giovanni", text: "soluzioni per aziende" }
    ]
  },
  "sviluppo-siti-web-professionali": {
    heroTitle: "Sviluppo siti web professionali a",
    heroHighlight: "architetture enterprise per PMI",
    heroSubtitle: "Non sviluppiamo semplici siti: costruiamo infrastrutture digitali. Web app, CRM custom, gestionali integrati e automazioni aziendali con le stesse tecnologie usate dalle big tech, accessibili anche alle PMI di Sesto San Giovanni.",
    metaTitleTemplate: "Sviluppo Siti Web Professionali Sesto San Giovanni | Qualità e Performance",
    metaDescTemplate: "Sviluppo siti web professionali a Sesto San Giovanni. Tecnologie moderne, codice pulito, performance elevate. Per progetti che richiedono qualità.",
    problems: [
      "Usi 5 software diversi che non comunicano tra loro?",
      "I tuoi processi aziendali dipendono da file Excel condivisi?",
      "Hai bisogno di un gestionale ma quelli standard non si adattano?",
      "Vuoi automatizzare flussi complessi che nessun tool standard gestisce?"
    ],
    solutions: [
      { title: "Stack enterprise", desc: "React, Node.js, Python, MongoDB: le tecnologie delle startup di successo" },
      { title: "Integrazione totale", desc: "Un unico sistema che collega vendite, magazzino, contabilità, clienti" },
      { title: "Automazioni custom", desc: "Workflow su misura: da 'nuovo ordine' a 'fattura inviata' senza toccare nulla" },
      { title: "API-first", desc: "Tutto comunica con tutto: il tuo ecosistema digitale parla una lingua sola" }
    ],
    services: [
      "CRM e gestionali personalizzati",
      "Web app per processi aziendali",
      "Integrazioni API tra sistemi esistenti",
      "Automazioni workflow e notifiche"
    ],
    targetAudience: [
      { title: "PMI che scalano", desc: "Aziende che stanno superando i limiti dei fogli Excel" },
      { title: "Imprese multi-sede", desc: "Chi deve centralizzare dati da più punti vendita o filiali" },
      { title: "Aziende B2B", desc: "Gestione ordini, preventivi, clienti in un unico sistema" },
      { title: "Attività con processi complessi", desc: "Flussi che richiedono software su misura, non adattamenti" }
    ],
    results: [
      { title: "Un sistema, non dieci tool", desc: "Tutto integrato, tutto sotto controllo" },
      { title: "Ore risparmiate ogni giorno", desc: "Automazioni che eliminano il lavoro ripetitivo" },
      { title: "Decisioni basate sui dati", desc: "Dashboard in tempo reale su vendite, clienti, performance" },
      { title: "Scalabilità senza limiti", desc: "Il sistema cresce con te, modulo dopo modulo" }
    ],
    faqs: [
      {
        q: "Cosa intendete per 'CRM personalizzato'?",
        a: "Un CRM costruito sui tuoi processi, non il contrario. Se vendi servizi con preventivi complessi, cicli di approvazione, gestione commesse: sviluppiamo un sistema che fa esattamente quello che ti serve, integrato con il sito, l'email, la fatturazione."
      },
      {
        q: "Quanto costa sviluppare un gestionale su misura?",
        a: "Dipende dalla complessità. Un CRM base integrato col sito parte da 3-5.000€. Sistemi più complessi con automazioni avanzate da 8-15.000€. Ma il ROI si misura in ore risparmiate: spesso si ripaga in pochi mesi."
      },
      {
        q: "Posso collegare il nuovo sistema ai software che già uso?",
        a: "Nella maggior parte dei casi sì. Integriamo con Fatture in Cloud, Mailchimp, WhatsApp Business, Google Calendar, sistemi di pagamento e quasi tutti i software che espongono API. Analizziamo caso per caso."
      },
      {
        q: "Chi gestisce il sistema dopo lo sviluppo?",
        a: "Lo usi tu, in autonomia, con un'interfaccia semplice. Noi restiamo disponibili per manutenzione, aggiornamenti e nuove funzionalità. Offriamo contratti di supporto mensili per chi vuole la massima tranquillità."
      }
    ],
    ctaText: "Progettiamo la tua infrastruttura",
    ctaSubtext: "Sistemi che altri non sanno costruire. Raccontaci cosa ti serve.",
    internalLinks: [
      { url: "/web-designer-sesto-san-giovanni", text: "il nostro team" },
      { url: "/realizzazione-siti-web-sesto-san-giovanni", text: "realizzazione siti web" },
      { url: "/siti-web-responsive-seo-sesto-san-giovanni", text: "ottimizzazione performance e SEO" },
      { url: "/creazione-siti-web-aziende-sesto-san-giovanni", text: "soluzioni aziendali" }
    ]
  },
  "siti-web-responsive-seo": {
    heroTitle: "Siti web responsive e SEO a",
    heroHighlight: "visibilità che converte in sistema",
    heroSubtitle: "Farti trovare su Google è solo l'inizio. Sviluppiamo siti SEO-optimized che catturano traffico e lo trasformano in lead gestiti: form intelligenti, CRM integrato, follow-up automatici. Non solo visibilità, ma un funnel completo.",
    metaTitleTemplate: "Siti Web Responsive e SEO Sesto San Giovanni | Mobile-First e Ottimizzati",
    metaDescTemplate: "Siti web responsive e ottimizzati SEO a Sesto San Giovanni. Mobile-first, veloci, strutturati per posizionarsi su Google. Analisi SEO gratuita.",
    problems: [
      "Ricevi visite ma non sai da dove arrivano né cosa fanno?",
      "I contatti dal sito finiscono in una casella email caotica?",
      "Vorresti sapere quali pagine convertono e quali no?",
      "Il traffico c'è ma i lead si perdono nel nulla?"
    ],
    solutions: [
      { title: "SEO + Analytics integrati", desc: "Sappiamo da dove arrivano i visitatori e cosa cercano" },
      { title: "Form collegati a CRM", desc: "Ogni lead finisce nel sistema, taggato e pronto per il follow-up" },
      { title: "Automazioni post-conversione", desc: "Email di benvenuto, reminder, nurturing automatico" },
      { title: "Dashboard conversioni", desc: "Vedi in tempo reale quali pagine portano clienti" }
    ],
    services: [
      "Siti SEO con tracciamento avanzato",
      "Integrazione form-CRM automatica",
      "Setup funnel di conversione",
      "Automazioni email e WhatsApp post-lead"
    ],
    targetAudience: [
      { title: "Chi investe in marketing", desc: "Se paghi ads, devi sapere esattamente cosa rendono" },
      { title: "Chi ha traffico ma pochi lead", desc: "Il problema è nel funnel, non nella SEO" },
      { title: "Chi vuole scalare", desc: "Automatizzare la gestione lead per gestirne di più" },
      { title: "Chi odia perdere opportunità", desc: "Ogni contatto merita follow-up, automatico" }
    ],
    results: [
      { title: "Traffico tracciato", desc: "Sai esattamente cosa funziona e cosa no" },
      { title: "Lead mai persi", desc: "Ogni contatto entra in un sistema, non in una inbox" },
      { title: "Follow-up automatico", desc: "Rispondi in secondi, anche di notte" },
      { title: "ROI misurabile", desc: "Colleghi ogni euro speso in marketing a ogni lead generato" }
    ],
    faqs: [
      {
        q: "Cosa intendete per 'funnel di conversione'?",
        a: "È il percorso che trasforma un visitatore in cliente: landing page ottimizzata → form strategico → lead in CRM → email automatica → follow-up. Ogni step è tracciato, ogni perdita è identificabile e correggibile."
      },
      {
        q: "Posso collegare i form del sito al mio CRM esistente?",
        a: "Nella maggior parte dei casi sì: HubSpot, Pipedrive, Salesforce, Zoho, o anche un CRM custom. Se il tuo CRM ha API, lo integriamo. Altrimenti possiamo costruirtene uno su misura."
      },
      {
        q: "Come funzionano le automazioni post-lead?",
        a: "Esempio: qualcuno compila il form → riceve email di conferma istantanea → il commerciale riceve notifica WhatsApp → dopo 3 giorni parte reminder automatico se non c'è stata risposta. Tutto senza toccare nulla."
      },
      {
        q: "Quanto costa aggiungere queste automazioni a un sito esistente?",
        a: "Dipende dal sito e dal CRM. Un setup base (form → CRM → email automatica) parte da 500-800€. Funnel complessi con scoring lead e nurturing multi-step da 1.500€ in su. ROI tipico: poche settimane."
      }
    ],
    ctaText: "Trasforma il traffico in sistema",
    ctaSubtext: "SEO per farti trovare, automazioni per non perdere nessuno. Analizziamo insieme il tuo funnel.",
    internalLinks: [
      { url: "/web-designer-sesto-san-giovanni", text: "il nostro team di esperti" },
      { url: "/realizzazione-siti-web-sesto-san-giovanni", text: "realizzazione siti web" },
      { url: "/sviluppo-siti-web-professionali-sesto-san-giovanni", text: "sviluppo professionale" },
      { url: "/creazione-siti-web-aziende-sesto-san-giovanni", text: "siti per aziende" }
    ]
  },
  "creazione-siti-web-aziende": {
    heroTitle: "Creazione siti web per aziende a",
    heroHighlight: "ecosistemi digitali completi",
    heroSubtitle: "Per le aziende di Sesto San Giovanni che pensano in grande: non creiamo siti, costruiamo ecosistemi digitali. Sito + CRM + gestionale + automazioni, tutto integrato. Un unico partner tecnologico per tutta la tua infrastruttura digitale.",
    metaTitleTemplate: "Creazione Siti Web Aziende Sesto San Giovanni | Soluzioni Business",
    metaDescTemplate: "Creiamo siti web per aziende a Sesto San Giovanni. Soluzioni orientate al business: lead generation, integrazione CRM, conversione. Consulenza gratuita.",
    problems: [
      "Hai sito, CRM, gestionale, email marketing... e niente comunica con niente?",
      "Ogni nuovo strumento richiede un nuovo fornitore da gestire?",
      "I dati dei clienti sono sparpagliati su 5 piattaforme diverse?",
      "Vorresti un unico sistema ma sembrava impossibile?"
    ],
    solutions: [
      { title: "Ecosistema unificato", desc: "Sito, CRM, gestionale, automazioni: un unico sistema coerente" },
      { title: "Un partner, non dieci fornitori", desc: "Sviluppiamo e manteniamo tutta la tua infrastruttura digitale" },
      { title: "Dati centralizzati", desc: "Cliente, ordini, fatture, comunicazioni: tutto in un posto" },
      { title: "Scalabilità modulare", desc: "Parti da ciò che serve oggi, aggiungi moduli domani" }
    ],
    services: [
      "Ecosistemi digitali aziendali completi",
      "CRM e gestionali integrati con il sito",
      "Portali B2B con area clienti e ordini",
      "Automazioni end-to-end (dal lead alla fattura)"
    ],
    targetAudience: [
      { title: "Aziende stanche di rattoppi", desc: "Chi ha provato a integrare tool diversi e ha fallito" },
      { title: "PMI ambiziose", desc: "Chi vuole strumenti da grande azienda a budget da PMI" },
      { title: "Imprese B2B", desc: "Gestione clienti, preventivi, ordini, tutto automatizzato" },
      { title: "Aziende multi-reparto", desc: "Commerciale, amministrazione, operations: tutti sullo stesso sistema" }
    ],
    results: [
      { title: "Una fonte di verità", desc: "Tutti i dati in un posto, sempre aggiornati" },
      { title: "Processi automatizzati", desc: "Dal primo contatto alla fattura, senza data entry" },
      { title: "Team allineati", desc: "Commerciale e amministrazione vedono gli stessi dati" },
      { title: "Crescita senza caos", desc: "Scali il business, non la complessità gestionale" }
    ],
    faqs: [
      {
        q: "Cosa intendete per 'ecosistema digitale'?",
        a: "Un insieme integrato dove: il sito genera lead → il lead finisce nel CRM → il commerciale crea un preventivo → il cliente accetta dall'area riservata → l'ordine va al gestionale → la fattura parte automatica. Zero passaggi manuali tra un sistema e l'altro."
      },
      {
        q: "Possiamo migrare i dati dai sistemi attuali?",
        a: "Sì, ci occupiamo della migrazione. Analizziamo i tuoi dati attuali (Excel, vecchi CRM, gestionali), li puliamo e li importiamo nel nuovo sistema. Nessun dato viene perso, nessuna interruzione operativa."
      },
      {
        q: "Quanto tempo serve per implementare un ecosistema completo?",
        a: "Dipende dalla complessità. Un ecosistema base (sito + CRM + automazioni email) richiede 4-6 settimane. Sistemi più complessi con gestionale e portale B2B richiedono 2-4 mesi. Lavoriamo in fasi, quindi inizi a usare i primi moduli mentre sviluppiamo il resto."
      },
      {
        q: "Chi gestisce l'ecosistema dopo il lancio?",
        a: "Tu e il tuo team, con interfacce semplici e intuitive. Noi restiamo il partner tecnologico: manutenzione, aggiornamenti, nuove funzionalità, supporto. Un unico interlocutore per tutto il digitale della tua azienda."
      }
    ],
    ctaText: "Costruiamo il tuo ecosistema",
    ctaSubtext: "Un sistema, un partner, zero caos. Parliamo di come digitalizzare davvero la tua azienda.",
    internalLinks: [
      { url: "/web-designer-sesto-san-giovanni", text: "il nostro team" },
      { url: "/realizzazione-siti-web-sesto-san-giovanni", text: "realizzazione siti web" },
      { url: "/sviluppo-siti-web-professionali-sesto-san-giovanni", text: "sviluppo con tecnologie professionali" },
      { url: "/siti-web-responsive-seo-sesto-san-giovanni", text: "ottimizzazione SEO" }
    ]
  }
};

// Contenuti specifici per Lugano - Cluster SEO ottimizzato per mercato svizzero
const luganoContent = {
  "web-designer": {
    heroTitle: "Web Designer a",
    heroHighlight: "partner per progetti digitali",
    heroSubtitle: "Progettiamo e sviluppiamo sistemi digitali per aziende e professionisti del Luganese. Non realizziamo semplicemente siti web: analizziamo le esigenze, progettiamo soluzioni su misura e costruiamo strumenti che funzionano.",
    metaTitleTemplate: "Web Designer Lugano | Sistemi Digitali per Aziende | M&M",
    metaDescTemplate: "Web designer a Lugano: progettiamo siti web, web app, gestionali e automazioni per aziende e professionisti del Ticino. Consulenza gratuita.",
    problems: [
      "Hai bisogno di digitalizzare processi ma non sai da dove iniziare?",
      "Cerchi un partner che comprenda le esigenze della tua azienda?",
      "Vorresti un sistema su misura, non un prodotto standardizzato?",
      "I tuoi strumenti digitali attuali non comunicano tra loro?"
    ],
    solutions: [
      { title: "Analisi delle esigenze", desc: "Partiamo dal problema aziendale, non dalla tecnologia" },
      { title: "Progettazione su misura", desc: "Siti, web app, gestionali, automazioni: ciò che serve davvero" },
      { title: "Sviluppo professionale", desc: "Tecnologie moderne, codice pulito, performance elevate" },
      { title: "Supporto continuativo", desc: "Il progetto evolve con la tua azienda" }
    ],
    services: [
      "Siti web aziendali e professionali",
      "Web app e gestionali personalizzati",
      "Automazioni e integrazioni tra sistemi",
      "Ottimizzazione SEO e presenza online"
    ],
    targetAudience: [
      { title: "Aziende e PMI", desc: "Imprese che vogliono digitalizzare processi e acquisire clienti" },
      { title: "Studi professionali", desc: "Avvocati, commercialisti, consulenti che cercano strumenti efficaci" },
      { title: "Professionisti sanitari", desc: "Dentisti, fisioterapisti, psicologi con esigenze di prenotazione e gestione" },
      { title: "Attività di servizi", desc: "Aziende tecniche e di servizi che vogliono automatizzare richieste e preventivi" }
    ],
    results: [
      { title: "Soluzione proporzionata", desc: "Progetti dimensionati sulle reali esigenze" },
      { title: "Processi digitalizzati", desc: "Meno lavoro manuale, più efficienza operativa" },
      { title: "Presenza online efficace", desc: "Visibilità e acquisizione di nuove richieste" },
      { title: "Sistema che evolve", desc: "Possibilità di aggiungere funzionalità nel tempo" }
    ],
    faqs: [
      {
        q: "Quali tipi di progetti realizzate?",
        a: "Progettiamo siti web aziendali, landing page, e-commerce, web app, gestionali personalizzati e automazioni. Ogni progetto parte dall'analisi delle esigenze specifiche per proporre la soluzione più adatta."
      },
      {
        q: "Lavorate con aziende del Canton Ticino?",
        a: "Sì, lavoriamo con aziende, PMI e professionisti di Lugano e del Canton Ticino. Organizziamo incontri per comprendere le esigenze e proporre soluzioni concrete."
      },
      {
        q: "Cosa distingue un sistema digitale da un semplice sito web?",
        a: "Un sito web è una vetrina. Un sistema digitale può includere il sito, ma anche CRM per gestire i contatti, automazioni per follow-up, gestionali per preventivi e ordini. Ogni componente è progettato in base alle esigenze del progetto."
      },
      {
        q: "Come funziona la consulenza iniziale?",
        a: "La prima consulenza è gratuita e senza impegno. Analizziamo insieme la situazione attuale, le esigenze e gli obiettivi. Successivamente proponiamo una soluzione con preventivo dettagliato."
      }
    ],
    ctaText: "Parliamo del tuo progetto",
    ctaSubtext: "Raccontaci la tua esigenza. Troveremo insieme la soluzione più adatta.",
    internalLinks: [
      { url: "/realizzazione-siti-web-lugano", text: "realizzazione siti web" },
      { url: "/sviluppo-siti-web-professionali-lugano", text: "sviluppo professionale" },
      { url: "/siti-web-responsive-seo-lugano", text: "ottimizzazione SEO" },
      { url: "/creazione-siti-web-aziende-lugano", text: "soluzioni per aziende" }
    ],
    // Sezioni personalizzate per web-designer (HUB)
    whyDigitalSection: {
      title: "Perché oggi serve più di un sito web",
      paragraphs: [
        "Il sito web è solo una parte della presenza digitale di un'azienda. Oggi serve un <strong class='text-white'>sistema digitale</strong> che integri comunicazione, acquisizione clienti, gestione dei contatti e automazione dei processi.",
        "A Lugano e nel Canton Ticino, aziende e professionisti cercano partner in grado di comprendere le esigenze di business e proporre soluzioni digitali proporzionate: non sempre serve tutto, ma ciò che serve deve funzionare.",
        "M&M Web Designers progetta sistemi digitali partendo dall'analisi dell'esigenza, non dalla tecnologia. Il risultato è una soluzione su misura che può includere sito, web app, CRM, gestionali o automazioni — a seconda di ciò che serve davvero."
      ],
      miniCtaText: "Hai un'esigenza da digitalizzare? Parliamone insieme, la consulenza iniziale è gratuita."
    },
    processSection: {
      title: "Il nostro approccio",
      subtitle: "Ogni progetto digitale parte da un'esigenza, non da un template."
    },
    processSteps: [
      { title: "Ascolto", desc: "Comprendiamo l'esigenza aziendale, i processi attuali, gli obiettivi" },
      { title: "Analisi", desc: "Valutiamo le opzioni e proponiamo la soluzione più adatta" },
      { title: "Progettazione", desc: "Definiamo architettura, funzionalità e tempi di sviluppo" },
      { title: "Evoluzione", desc: "Il sistema cresce con l'azienda, aggiungendo moduli quando servono" }
    ],
    differencesSection: {
      title: "Perché scegliere M&M",
      subtitle: "Non vendiamo pacchetti standard. Progettiamo soluzioni su misura per ogni esigenza."
    },
    differences: [
      { wrong: "Pacchetti preconfezionati", right: "Soluzioni progettate sull'esigenza" },
      { wrong: "Solo siti vetrina", right: "Sistemi digitali completi" },
      { wrong: "Sparire dopo la consegna", right: "Supporto e evoluzione nel tempo" },
      { wrong: "Tecnologie obsolete", right: "Stack moderni e performanti" }
    ],
    seoLocalSection: {
      title: "Sistemi digitali per il Ticino",
      intro: "Lavoriamo con aziende e professionisti di Lugano e del Canton Ticino. Conosciamo il tessuto imprenditoriale locale e le esigenze di chi fa business in Svizzera italiana.",
      columns: [
        { title: "Consulenza in loco", desc: "Ci incontriamo di persona per capire a fondo le esigenze" },
        { title: "Soluzioni scalabili", desc: "Sistemi che crescono con l'azienda, senza dover ripartire da zero" },
        { title: "Supporto continuativo", desc: "Assistenza, manutenzione e sviluppo di nuove funzionalità" }
      ],
      outro: "Che si tratti di un sito, una web app o un gestionale personalizzato, progettiamo soluzioni digitali concrete per il mercato ticinese."
    },
    targetSection: {
      title: "A chi ci rivolgiamo",
      subtitle: "Lavoriamo con aziende, PMI e professionisti di Lugano e del Canton Ticino."
    }
  },
  "realizzazione-siti-web": {
    heroTitle: "Realizzazione siti web a",
    heroHighlight: "progettati per funzionare",
    heroSubtitle: "Realizziamo siti web per aziende e professionisti di Lugano. Ogni progetto è pensato per raggiungere obiettivi concreti: farsi trovare, comunicare in modo efficace, generare richieste di contatto.",
    metaTitleTemplate: "Realizzazione Siti Web Lugano | Siti Aziendali Ticino | M&M",
    metaDescTemplate: "Realizzazione siti web a Lugano per aziende e professionisti. Siti aziendali, landing page, e-commerce. Preventivo gratuito.",
    problems: [
      "Il tuo sito attuale non genera richieste di contatto?",
      "Hai bisogno di un sito nuovo o di rifare quello esistente?",
      "Vuoi un sito che possa crescere con la tua azienda?",
      "Cerchi un progetto chiaro, con tempi e costi definiti?"
    ],
    solutions: [
      { title: "Progettazione orientata agli obiettivi", desc: "Ogni pagina ha uno scopo preciso nel percorso del visitatore" },
      { title: "Struttura predisposta per evoluzioni", desc: "Il sito può essere collegato a CRM, automazioni, gestionali" },
      { title: "SEO tecnica integrata", desc: "Struttura, velocità e contenuti ottimizzati per i motori di ricerca" },
      { title: "Processo trasparente", desc: "Preventivo dettagliato, tempi definiti, nessuna sorpresa" }
    ],
    services: [
      "Siti web aziendali e corporate",
      "Landing page per campagne e servizi",
      "Siti per professionisti e studi",
      "E-commerce e cataloghi prodotti"
    ],
    targetAudience: [
      { title: "Aziende senza sito", desc: "Chi ha bisogno di una presenza online professionale" },
      { title: "Aziende con sito datato", desc: "Chi vuole aggiornare tecnologia e immagine" },
      { title: "Professionisti", desc: "Studi e liberi professionisti che cercano visibilità" },
      { title: "Nuove attività", desc: "Imprese in fase di avvio che vogliono partire con il piede giusto" }
    ],
    results: [
      { title: "Presenza online professionale", desc: "Un sito che rappresenta adeguatamente la tua attività" },
      { title: "Visibilità sui motori di ricerca", desc: "SEO base inclusa per farti trovare" },
      { title: "Generazione di contatti", desc: "Struttura pensata per convertire visitatori in richieste" },
      { title: "Base per evoluzioni future", desc: "Architettura pronta per integrazioni quando necessario" }
    ],
    faqs: [
      {
        q: "Quanto costa realizzare un sito web aziendale?",
        a: "Un sito aziendale professionale parte da CHF 1.500-3.000 per un sito vetrina. E-commerce e progetti con funzionalità avanzate hanno costi superiori. Forniamo sempre un preventivo dettagliato prima di iniziare."
      },
      {
        q: "Quanto tempo serve per realizzare un sito?",
        a: "Un sito aziendale standard richiede 3-4 settimane. Progetti più complessi richiedono tempistiche maggiori. I tempi dipendono anche dalla rapidità nel fornire contenuti e feedback."
      },
      {
        q: "Il sito sarà ottimizzato per i motori di ricerca?",
        a: "Sì, tutti i nostri siti includono ottimizzazione SEO tecnica: struttura corretta, velocità di caricamento, responsive design, meta tag configurati. Attività SEO avanzate sono disponibili come servizio aggiuntivo."
      },
      {
        q: "Posso gestire i contenuti in autonomia?",
        a: "Sì, realizziamo siti con pannelli di gestione intuitivi che permettono di modificare testi e immagini senza competenze tecniche. Forniamo anche formazione sull'utilizzo."
      }
    ],
    ctaText: "Richiedi un preventivo",
    ctaSubtext: "Descrivi il tuo progetto. Ti rispondiamo con una proposta dettagliata.",
    internalLinks: [
      { url: "/web-designer-lugano", text: "il nostro approccio" },
      { url: "/sviluppo-siti-web-professionali-lugano", text: "sviluppo con tecnologie avanzate" },
      { url: "/siti-web-responsive-seo-lugano", text: "ottimizzazione SEO" },
      { url: "/creazione-siti-web-aziende-lugano", text: "soluzioni per aziende" }
    ],
    // Sezioni personalizzate per realizzazione-siti-web
    whyDigitalSection: {
      title: "Un sito web che lavora per te",
      paragraphs: [
        "Un sito web efficace non è solo una vetrina: è uno strumento che comunica, convince e genera contatti. Ogni elemento — dalla struttura alla grafica ai contenuti — deve guidare il visitatore verso l'azione.",
        "A Lugano e nel Canton Ticino, la concorrenza online è in crescita. Quando qualcuno cerca i tuoi servizi, il tuo sito deve comparire, convincere e convertire. Non basta esserci: bisogna esserci nel modo giusto.",
        "Realizziamo siti web <strong class='text-white'>progettati per obiettivi concreti</strong>: farsi trovare su Google, comunicare professionalità, generare richieste. E li costruiamo già predisposti per evoluzioni future."
      ],
      miniCtaText: "Vuoi un sito che porti risultati? Parliamone insieme."
    },
    processSection: {
      title: "Come realizziamo un sito",
      subtitle: "Un processo chiaro, tempi definiti, nessuna sorpresa."
    },
    processSteps: [
      { title: "Briefing", desc: "Raccogliamo informazioni sull'attività, gli obiettivi, il pubblico target" },
      { title: "Progettazione", desc: "Definiamo struttura, contenuti e design orientato alla conversione" },
      { title: "Sviluppo", desc: "Realizziamo il sito con tecnologie moderne, responsive e ottimizzato SEO" },
      { title: "Pubblicazione", desc: "Mettiamo online e ti formiamo per gestire i contenuti in autonomia" }
    ],
    differencesSection: {
      title: "Perché affidarsi a M&M",
      subtitle: "Realizziamo siti pensati per portare risultati, non solo per essere belli."
    },
    differences: [
      { wrong: "Solo estetica", right: "Struttura che converte" },
      { wrong: "Tempi indefiniti", right: "Consegna in 3-4 settimane" },
      { wrong: "Costi nascosti", right: "Preventivo chiaro e dettagliato" },
      { wrong: "Abbandono post-consegna", right: "Supporto e assistenza continua" }
    ],
    seoLocalSection: {
      title: "Siti web per aziende ticinesi",
      intro: "Realizziamo siti web per aziende e professionisti di Lugano e del Canton Ticino. Ogni progetto parte dalla comprensione del business per proporre una soluzione efficace.",
      columns: [
        { title: "SEO locale", desc: "Struttura ottimizzata per le ricerche nel territorio ticinese" },
        { title: "Design professionale", desc: "Immagine all'altezza delle aspettative del mercato svizzero" },
        { title: "Supporto dedicato", desc: "Assistenza in italiano, incontri di persona quando necessario" }
      ],
      outro: "Che tu abbia bisogno di un nuovo sito o di rifare quello esistente, progettiamo soluzioni concrete per il mercato locale."
    },
    targetSection: {
      title: "Per chi è pensato questo servizio",
      subtitle: "Lavoriamo con aziende e professionisti di Lugano e del Canton Ticino."
    }
  },
  "creazione-siti-web-aziende": {
    heroTitle: "Siti web per aziende a",
    heroHighlight: "strumenti di business",
    heroSubtitle: "Per le aziende di Lugano e del Ticino che vogliono trasformare la presenza online in uno strumento di lavoro. Non solo vetrina: acquisiamo contatti, gestiamo richieste, automatizziamo processi.",
    metaTitleTemplate: "Siti Web Aziende Lugano | Soluzioni Digitali PMI Ticino | M&M",
    metaDescTemplate: "Creiamo siti web per aziende a Lugano. Soluzioni orientate al business: acquisizione clienti, gestione contatti, automazioni. Consulenza gratuita.",
    problems: [
      "Il sito aziendale attuale non genera valore per il business?",
      "Le richieste dal web si perdono in caselle email disorganizzate?",
      "Vorresti automatizzare la gestione dei contatti commerciali?",
      "Cerchi una soluzione digitale che cresca con l'azienda?"
    ],
    solutions: [
      { title: "Orientamento al business", desc: "Ogni funzionalità è pensata per generare valore misurabile" },
      { title: "Gestione contatti strutturata", desc: "I lead vengono raccolti, organizzati e resi azionabili" },
      { title: "Possibilità di automazione", desc: "Risposte automatiche, notifiche, follow-up programmati" },
      { title: "Integrazione con strumenti aziendali", desc: "Collegamento con CRM, email marketing, gestionali" }
    ],
    services: [
      "Siti aziendali con generazione lead",
      "Aree riservate per clienti e partner",
      "Integrazione con CRM e sistemi aziendali",
      "Automazioni per gestione richieste"
    ],
    targetAudience: [
      { title: "PMI strutturate", desc: "Aziende con team commerciale che vogliono più richieste qualificate" },
      { title: "Aziende B2B", desc: "Imprese che vendono ad altre aziende e cercano lead" },
      { title: "Società di servizi", desc: "Consulenze, servizi professionali, assistenza tecnica" },
      { title: "Aziende in crescita", desc: "Realtà che stanno scalando e hanno bisogno di strumenti adeguati" }
    ],
    results: [
      { title: "Acquisizione lead qualificati", desc: "Il sito diventa un canale di generazione contatti" },
      { title: "Processi più efficienti", desc: "Meno lavoro manuale nella gestione delle richieste" },
      { title: "Dati organizzati", desc: "Informazioni sui contatti strutturate e accessibili" },
      { title: "Scalabilità", desc: "Il sistema può evolvere aggiungendo funzionalità" }
    ],
    faqs: [
      {
        q: "Come può un sito generare lead per la mia azienda?",
        a: "Attraverso form strategici, contenuti che rispondono alle domande dei potenziali clienti, SEO per intercettare ricerche pertinenti e call-to-action efficaci. Ogni contatto viene tracciato e organizzato."
      },
      {
        q: "Potete integrare il sito con il nostro CRM?",
        a: "Sì, realizziamo integrazioni con i principali CRM e strumenti di marketing automation. I lead raccolti dal sito possono confluire automaticamente nei vostri sistemi."
      },
      {
        q: "Quali automazioni sono possibili?",
        a: "Email di conferma automatiche, notifiche al team commerciale, reminder per follow-up, risposte automatiche fuori orario. Le automazioni vengono configurate in base ai vostri processi."
      },
      {
        q: "Il sito può avere un'area riservata per i clienti?",
        a: "Sì, possiamo sviluppare aree riservate per condividere documenti, preventivi, stati avanzamento progetti o qualsiasi contenuto dedicato a clienti o partner specifici."
      }
    ],
    ctaText: "Parliamo della tua azienda",
    ctaSubtext: "Raccontaci gli obiettivi di business. Progettiamo insieme la soluzione digitale.",
    internalLinks: [
      { url: "/web-designer-lugano", text: "il nostro approccio" },
      { url: "/realizzazione-siti-web-lugano", text: "realizzazione siti web" },
      { url: "/sviluppo-siti-web-professionali-lugano", text: "sviluppo avanzato" },
      { url: "/siti-web-responsive-seo-lugano", text: "ottimizzazione SEO" }
    ],
    // Sezioni personalizzate per creazione-siti-web-aziende
    whyDigitalSection: {
      title: "Il sito come strumento di business",
      paragraphs: [
        "Per un'azienda, il sito web non è una vetrina: è uno <strong class='text-white'>strumento di acquisizione e gestione</strong>. Deve generare richieste, qualificare i contatti, integrarsi con i processi aziendali.",
        "A Lugano e nel Ticino, le aziende cercano soluzioni digitali che producano valore misurabile. Non basta 'essere online': serve un sistema che acquisisca clienti, organizzi le informazioni, automatizzi ciò che può essere automatizzato.",
        "M&M Web Designers progetta siti per aziende partendo dagli obiettivi di business, non dalla grafica. Il risultato è una presenza digitale che lavora per te, 24 ore su 24."
      ],
      miniCtaText: "Vuoi un sito che generi valore per la tua azienda? Parliamone."
    },
    processSection: {
      title: "Dal business alla soluzione",
      subtitle: "Partiamo dagli obiettivi aziendali, non dalle funzionalità tecniche."
    },
    processSteps: [
      { title: "Obiettivi", desc: "Capiamo cosa deve fare il sito per la tua azienda" },
      { title: "Strategia", desc: "Definiamo come acquisire, qualificare e gestire i contatti" },
      { title: "Realizzazione", desc: "Sviluppiamo il sito e le integrazioni necessarie" },
      { title: "Ottimizzazione", desc: "Monitoriamo i risultati e miglioriamo nel tempo" }
    ],
    differencesSection: {
      title: "Perché scegliere M&M per la tua azienda",
      subtitle: "Non vendiamo siti: costruiamo strumenti di business digitale."
    },
    differences: [
      { wrong: "Sito vetrina statico", right: "Sistema di acquisizione clienti" },
      { wrong: "Contatti che si perdono", right: "Lead organizzati e azionabili" },
      { wrong: "Processi manuali", right: "Automazioni dove servono" },
      { wrong: "Strumenti scollegati", right: "Integrazioni con CRM e gestionali" }
    ],
    seoLocalSection: {
      title: "Soluzioni digitali per aziende ticinesi",
      intro: "Lavoriamo con PMI, aziende B2B e società di servizi di Lugano e del Canton Ticino. Conosciamo le dinamiche del mercato locale e le esigenze di chi fa business in Svizzera.",
      columns: [
        { title: "Focus sui risultati", desc: "Ogni progetto è valutato in base al valore che genera" },
        { title: "Integrazioni aziendali", desc: "Collegamento con CRM, ERP, strumenti di gestione" },
        { title: "Scalabilità", desc: "Soluzioni che crescono con l'azienda" }
      ],
      outro: "Che tu voglia acquisire più clienti, gestire meglio i contatti o automatizzare processi, progettiamo la soluzione digitale adatta al tuo business."
    },
    targetSection: {
      title: "A quali aziende ci rivolgiamo",
      subtitle: "Lavoriamo con PMI, aziende B2B e società di servizi del Canton Ticino."
    }
  },
  "sviluppo-siti-web-professionali": {
    heroTitle: "Sviluppo web professionale a",
    heroHighlight: "soluzioni su misura",
    heroSubtitle: "Per aziende e professionisti di Lugano con esigenze che vanno oltre il sito vetrina. Sviluppiamo web app, gestionali personalizzati, automazioni e integrazioni tra sistemi.",
    metaTitleTemplate: "Sviluppo Web Professionale Lugano | Web App e Gestionali | M&M",
    metaDescTemplate: "Sviluppo web professionale a Lugano. Web app, gestionali personalizzati, automazioni, integrazioni API. Per aziende con esigenze avanzate.",
    problems: [
      "Hai bisogno di funzionalità che un sito standard non può offrire?",
      "I software disponibili sul mercato non si adattano ai tuoi processi?",
      "Vorresti automatizzare flussi di lavoro complessi?",
      "I tuoi sistemi attuali non comunicano tra loro?"
    ],
    solutions: [
      { title: "Analisi dei processi", desc: "Comprendiamo come lavori per progettare la soluzione giusta" },
      { title: "Sviluppo su misura", desc: "Software costruito sulle tue esigenze specifiche" },
      { title: "Integrazioni API", desc: "Colleghiamo i tuoi sistemi esistenti in un flusso coerente" },
      { title: "Automazioni intelligenti", desc: "Riduciamo il lavoro manuale dove ha senso farlo" }
    ],
    services: [
      "Web app personalizzate",
      "Gestionali e CRM su misura",
      "Automazioni di processo",
      "Integrazioni tra sistemi e API"
    ],
    targetAudience: [
      { title: "Aziende con processi specifici", desc: "Realtà che hanno bisogno di software su misura" },
      { title: "Imprese multi-reparto", desc: "Organizzazioni che devono far dialogare team diversi" },
      { title: "Attività con flussi complessi", desc: "Preventivi, ordini, commesse, progetti da gestire" },
      { title: "Chi vuole automatizzare", desc: "Aziende pronte a ridurre il lavoro manuale ripetitivo" }
    ],
    results: [
      { title: "Software che fa quello che serve", desc: "Niente funzionalità inutili, niente compromessi" },
      { title: "Processi semplificati", desc: "Flussi di lavoro più lineari e meno errori" },
      { title: "Dati integrati", desc: "Informazioni che fluiscono tra i sistemi automaticamente" },
      { title: "Tempo risparmiato", desc: "Ore di lavoro manuale eliminate ogni settimana" }
    ],
    faqs: [
      {
        q: "Che differenza c'è tra un sito web e una web app?",
        a: "Un sito web presenta informazioni. Una web app permette di fare cose: gestire dati, elaborare informazioni, automatizzare processi. Esempio: un sito mostra i tuoi servizi, una web app gestisce prenotazioni, preventivi, ordini."
      },
      {
        q: "Quanto costa sviluppare un gestionale su misura?",
        a: "Dipende dalla complessità. Un sistema base parte da CHF 5.000-8.000. Soluzioni più articolate con automazioni avanzate hanno costi superiori. Forniamo sempre un preventivo dettagliato dopo l'analisi delle esigenze."
      },
      {
        q: "Posso partire con una versione base e poi espandere?",
        a: "È l'approccio che consigliamo. Sviluppiamo un nucleo funzionante che risolve il problema principale, poi aggiungiamo moduli e funzionalità in base all'evoluzione delle esigenze."
      },
      {
        q: "Quali tecnologie utilizzate?",
        a: "Utilizziamo tecnologie moderne e affidabili: React per le interfacce, Python e Node.js per il backend, MongoDB e PostgreSQL per i database. La scelta dipende dalle esigenze specifiche del progetto."
      }
    ],
    ctaText: "Descrivi la tua esigenza",
    ctaSubtext: "Hai un processo da digitalizzare? Analizziamolo insieme.",
    internalLinks: [
      { url: "/web-designer-lugano", text: "il nostro approccio" },
      { url: "/realizzazione-siti-web-lugano", text: "realizzazione siti web" },
      { url: "/creazione-siti-web-aziende-lugano", text: "soluzioni per aziende" },
      { url: "/siti-web-responsive-seo-lugano", text: "ottimizzazione SEO" }
    ],
    // Sezioni personalizzate per sviluppo-siti-web-professionali
    whyDigitalSection: {
      title: "Quando serve più di un sito",
      paragraphs: [
        "Alcune esigenze non si risolvono con un sito web tradizionale. Serve un <strong class='text-white'>software su misura</strong>: una web app che gestisce prenotazioni, un gestionale per preventivi e commesse, automazioni che eliminano il lavoro manuale.",
        "In Svizzera e nel Canton Ticino, molte aziende hanno processi specifici che i software standard non riescono a gestire. La soluzione? Sviluppare strumenti digitali progettati sulle proprie esigenze.",
        "M&M Web Designers sviluppa web app, gestionali e automazioni utilizzando tecnologie moderne (React, Python, Node.js). Non proponiamo soluzioni sovradimensionate: progettiamo ciò che serve, con possibilità di espansione futura."
      ],
      miniCtaText: "Hai un processo complesso da digitalizzare? Analizziamolo insieme."
    },
    processSection: {
      title: "Come sviluppiamo soluzioni su misura",
      subtitle: "Dall'analisi del problema alla realizzazione del software."
    },
    processSteps: [
      { title: "Analisi", desc: "Comprendiamo i processi attuali e le esigenze specifiche" },
      { title: "Architettura", desc: "Progettiamo la struttura tecnica e le funzionalità" },
      { title: "Sviluppo", desc: "Realizziamo il software in fasi, validando con il cliente" },
      { title: "Deploy", desc: "Mettiamo in produzione e formiamo il team sull'utilizzo" }
    ],
    differencesSection: {
      title: "Perché sviluppare con M&M",
      subtitle: "Soluzioni proporzionate alle esigenze, non progetti sovradimensionati."
    },
    differences: [
      { wrong: "Software standard inadatti", right: "Strumenti progettati sui tuoi processi" },
      { wrong: "Progetti faraonici", right: "Soluzioni proporzionate e scalabili" },
      { wrong: "Tecnologie obsolete", right: "Stack moderni (React, Python, Node.js)" },
      { wrong: "Nessun supporto post-rilascio", right: "Manutenzione e evoluzione continua" }
    ],
    seoLocalSection: {
      title: "Sviluppo software per il Ticino",
      intro: "Sviluppiamo web app, gestionali e automazioni per aziende di Lugano e del Canton Ticino. Ci incontriamo di persona per capire i processi e proporre soluzioni concrete.",
      columns: [
        { title: "Analisi approfondita", desc: "Comprendiamo il business prima di scrivere codice" },
        { title: "Sviluppo iterativo", desc: "Rilasci progressivi per validare con il cliente" },
        { title: "Supporto continuativo", desc: "Manutenzione, aggiornamenti e nuove funzionalità" }
      ],
      outro: "Che si tratti di un gestionale, una web app o automazioni tra sistemi, sviluppiamo soluzioni digitali che risolvono problemi reali."
    },
    targetSection: {
      title: "A chi è rivolto questo servizio",
      subtitle: "Aziende con esigenze avanzate che i software standard non soddisfano."
    }
  },
  "siti-web-responsive-seo": {
    heroTitle: "Siti responsive e SEO a",
    heroHighlight: "visibilità e performance",
    heroSubtitle: "Siti web che funzionano su ogni dispositivo e si posizionano sui motori di ricerca. Per aziende di Lugano e del Ticino che vogliono essere trovate da chi cerca i loro servizi.",
    metaTitleTemplate: "Siti Web Responsive SEO Lugano | Ottimizzazione Ticino | M&M",
    metaDescTemplate: "Siti web responsive e ottimizzati SEO a Lugano. Mobile-first, performance elevate, visibilità su Google. Analisi gratuita.",
    problems: [
      "Il tuo sito non compare nelle ricerche pertinenti?",
      "I potenziali clienti non ti trovano quando cercano i tuoi servizi?",
      "Il sito è lento o si vede male da smartphone?",
      "Non sai come funziona la SEO e cosa serve davvero?"
    ],
    solutions: [
      { title: "Architettura SEO corretta", desc: "Struttura, URL, heading e contenuti ottimizzati" },
      { title: "Design mobile-first", desc: "Prima lo smartphone, poi il desktop" },
      { title: "Performance elevate", desc: "Velocità di caricamento e Core Web Vitals ottimizzati" },
      { title: "Contenuti strategici", desc: "Testi che rispondono alle domande del tuo target" }
    ],
    services: [
      "Sviluppo siti mobile-first responsive",
      "Ottimizzazione SEO on-page",
      "Ottimizzazione velocità e performance",
      "Analisi e miglioramento siti esistenti"
    ],
    targetAudience: [
      { title: "Attività locali", desc: "Chi vuole essere trovato nelle ricerche della zona" },
      { title: "Chi ha un sito lento", desc: "Siti che penalizzano l'esperienza utente" },
      { title: "Chi non appare su Google", desc: "Siti con problemi di struttura SEO" },
      { title: "Chi punta al mobile", desc: "Business con clienti che cercano da smartphone" }
    ],
    results: [
      { title: "Migliore posizionamento", desc: "Visibilità per le ricerche pertinenti" },
      { title: "Esperienza utente ottimale", desc: "Il sito funziona bene su qualsiasi dispositivo" },
      { title: "Caricamento veloce", desc: "Tempi di risposta che non fanno scappare i visitatori" },
      { title: "Traffico qualificato", desc: "Visitatori che cercano effettivamente i tuoi servizi" }
    ],
    faqs: [
      {
        q: "Cosa significa che un sito è 'responsive'?",
        a: "Un sito responsive si adatta automaticamente a qualsiasi schermo: smartphone, tablet, desktop. Non è una versione separata, ma lo stesso sito che cambia layout in base al dispositivo. È fondamentale perché la maggior parte delle ricerche avviene da mobile."
      },
      {
        q: "Quanto tempo serve per vedere risultati SEO?",
        a: "La SEO richiede tempo. Per keyword locali in mercati non troppo competitivi, si possono vedere miglioramenti in 2-3 mesi. Per keyword più competitive servono 6-12 mesi. Il sito viene ottimizzato subito, i risultati arrivano gradualmente."
      },
      {
        q: "La SEO è inclusa nella realizzazione del sito?",
        a: "L'ottimizzazione SEO tecnica base è sempre inclusa: struttura corretta, velocità, responsive design, meta tag configurati. Attività SEO avanzate come content strategy, link building o campagne specifiche sono servizi aggiuntivi."
      },
      {
        q: "Potete analizzare il mio sito attuale?",
        a: "Sì, offriamo analisi SEO e performance del sito esistente. Identifichiamo problemi tecnici, opportunità di miglioramento e priorità di intervento. L'analisi iniziale è gratuita."
      }
    ],
    ctaText: "Richiedi un'analisi gratuita",
    ctaSubtext: "Analizziamo il tuo sito attuale e identifichiamo le opportunità di miglioramento.",
    internalLinks: [
      { url: "/web-designer-lugano", text: "il nostro approccio" },
      { url: "/realizzazione-siti-web-lugano", text: "realizzazione siti web" },
      { url: "/sviluppo-siti-web-professionali-lugano", text: "sviluppo professionale" },
      { url: "/creazione-siti-web-aziende-lugano", text: "siti per aziende" }
    ],
    // Sezioni personalizzate per siti-web-responsive-seo
    whyDigitalSection: {
      title: "Visibilità e performance: le basi del successo online",
      paragraphs: [
        "Un sito web che non si trova su Google o che si carica lentamente è un'opportunità persa. Ogni giorno, potenziali clienti cercano i tuoi servizi: se non compari tu, troveranno un concorrente.",
        "Nel Canton Ticino, la concorrenza online è in crescita. Un sito <strong class='text-white'>ottimizzato SEO</strong> e <strong class='text-white'>performante su mobile</strong> non è più un'opzione: è una necessità per chi vuole acquisire clienti dal web.",
        "M&M Web Designers realizza siti tecnicamente solidi: responsive design, velocità di caricamento, struttura SEO corretta. Non promettiamo il primo posto su Google, ma costruiamo le fondamenta perché il tuo sito possa competere."
      ],
      miniCtaText: "Vuoi sapere come si comporta il tuo sito? Ti offriamo un'analisi gratuita."
    },
    processSection: {
      title: "Come ottimizziamo un sito",
      subtitle: "Un approccio tecnico e metodico alla performance e alla visibilità."
    },
    processSteps: [
      { title: "Audit", desc: "Analizziamo velocità, struttura, SEO tecnica, mobile-friendliness" },
      { title: "Priorità", desc: "Identifichiamo gli interventi con maggiore impatto" },
      { title: "Implementazione", desc: "Ottimizziamo codice, immagini, struttura, meta tag" },
      { title: "Monitoraggio", desc: "Verifichiamo i miglioramenti e correggiamo il tiro" }
    ],
    differencesSection: {
      title: "Perché M&M per SEO e performance",
      subtitle: "Ottimizzazione basata su dati, non su promesse."
    },
    differences: [
      { wrong: "Promesse di primi posti", right: "Ottimizzazione tecnica reale" },
      { wrong: "Siti lenti e pesanti", right: "Performance ottimizzate" },
      { wrong: "Design solo desktop", right: "Mobile-first responsive" },
      { wrong: "SEO improvvisata", right: "Struttura e contenuti strategici" }
    ],
    seoLocalSection: {
      title: "SEO e performance per il Ticino",
      intro: "Ottimizziamo siti web per aziende di Lugano e del Canton Ticino. L'obiettivo è farsi trovare da chi cerca i tuoi servizi nella zona, con un sito veloce e funzionale su ogni dispositivo.",
      columns: [
        { title: "SEO locale", desc: "Ottimizzazione per ricerche nel territorio ticinese" },
        { title: "Core Web Vitals", desc: "Metriche di performance monitorate e ottimizzate" },
        { title: "Mobile-first", desc: "Progettazione partendo dall'esperienza smartphone" }
      ],
      outro: "Che tu abbia bisogno di un nuovo sito ottimizzato o di migliorare quello esistente, possiamo aiutarti a essere più visibile e più veloce."
    },
    targetSection: {
      title: "A chi è rivolto questo servizio",
      subtitle: "Aziende e professionisti del Canton Ticino che vogliono essere trovati online."
    }
  }
};

// Funzione per ottenere contenuti specifici per città e servizio
export const getServiceContent = (serviceId, cityId) => {
  // Per Sesto San Giovanni usiamo contenuti ottimizzati
  if (cityId === "sesto-san-giovanni" && sestoSanGiovanniContent[serviceId]) {
    return sestoSanGiovanniContent[serviceId];
  }
  // Per Lugano usiamo contenuti ottimizzati per mercato svizzero
  if (cityId === "lugano" && luganoContent[serviceId]) {
    return luganoContent[serviceId];
  }
  // Per altre città, ritorna null (userà i contenuti default)
  return null;
};

export const seoServices = [
  {
    id: "realizzazione-siti-web",
    name: "Realizzazione Siti Web",
    heroTitle: "Siti web a",
    heroHighlight: "che portano clienti",
    heroSubtitle: "Non solo bella grafica. Progettiamo siti pensati per farti trovare su Google e trasformare i visitatori in contatti reali.",
    metaTitleTemplate: "Realizzazione Siti Web {city} | Siti che Portano Clienti",
    metaDescTemplate: "Realizziamo siti web a {city} che portano clienti veri, non solo bella grafica. Preventivo gratuito in 24h."
  },
  {
    id: "web-designer",
    name: "Web Designer",
    heroTitle: "Web Designer a",
    heroHighlight: "al tuo servizio",
    heroSubtitle: "Un team di web designer professionisti pronti a creare la presenza online perfetta per la tua attivita.",
    metaTitleTemplate: "Web Designer {city} | Siti Professionali su Misura",
    metaDescTemplate: "Web designer a {city}: creiamo siti professionali, moderni e ottimizzati SEO. Consulenza gratuita."
  },
  {
    id: "creazione-siti-web-aziende",
    name: "Creazione Siti Web Aziende",
    heroTitle: "Siti web aziendali a",
    heroHighlight: "che fanno crescere il business",
    heroSubtitle: "Siti web professionali per aziende che vogliono distinguersi online e acquisire nuovi clienti.",
    metaTitleTemplate: "Creazione Siti Web Aziende {city} | Soluzioni Business",
    metaDescTemplate: "Creiamo siti web per aziende a {city}. Design professionale, SEO integrata, risultati garantiti."
  },
  {
    id: "sviluppo-siti-web-professionali",
    name: "Sviluppo Siti Web Professionali",
    heroTitle: "Sviluppo siti web professionali a",
    heroHighlight: "con tecnologie moderne",
    heroSubtitle: "Sviluppiamo siti web con le migliori tecnologie: veloci, sicuri e ottimizzati per i motori di ricerca.",
    metaTitleTemplate: "Sviluppo Siti Web Professionali {city} | Tecnologie Moderne",
    metaDescTemplate: "Sviluppo siti web professionali a {city}. Tecnologie moderne, performance elevate, supporto continuo."
  },
  {
    id: "siti-web-responsive-seo",
    name: "Siti Web Responsive SEO",
    heroTitle: "Siti responsive e SEO a",
    heroHighlight: "primi su Google",
    heroSubtitle: "Siti web ottimizzati per mobile e motori di ricerca. Fatti trovare dai tuoi potenziali clienti.",
    metaTitleTemplate: "Siti Web Responsive SEO {city} | Mobile-First e Ottimizzati",
    metaDescTemplate: "Siti web responsive e ottimizzati SEO a {city}. Mobile-first, veloci, pronti per Google."
  }
];

export const seoCities = [
  // Lombardia - Hinterland Milano
  {
    id: "sesto-san-giovanni",
    name: "Sesto San Giovanni",
    region: "Milano",
    localBusinesses: "negozi, studi professionali, artigiani e PMI",
    localAreas: ["Centro", "Rondo", "Marelli", "Cascina de' Gatti"],
    nearCities: ["Milano", "Monza", "Cinisello Balsamo", "Cologno Monzese"],
    localContext: "Con la sua posizione strategica alle porte di Milano e un tessuto economico dinamico fatto di PMI, artigiani e professionisti"
  },
  {
    id: "cinisello-balsamo",
    name: "Cinisello Balsamo",
    region: "Milano",
    localBusinesses: "attivita commerciali, professionisti, artigiani e piccole imprese",
    localAreas: ["Centro", "Balsamo", "Sant'Eusebio", "Crocetta"],
    nearCities: ["Milano", "Sesto San Giovanni", "Monza", "Cusano Milanino"],
    localContext: "Importante centro dell'hinterland milanese con un vivace tessuto commerciale e imprenditoriale"
  },
  {
    id: "bresso",
    name: "Bresso",
    region: "Milano",
    localBusinesses: "piccole imprese, negozi, professionisti e artigiani locali",
    localAreas: ["Centro", "Parco Nord", "Via Vittorio Veneto"],
    nearCities: ["Milano", "Sesto San Giovanni", "Cinisello Balsamo", "Cormano"],
    localContext: "Comune residenziale strategicamente posizionato tra Milano e la Brianza"
  },
  {
    id: "cologno-monzese",
    name: "Cologno Monzese",
    region: "Milano",
    localBusinesses: "aziende, attivita commerciali, studi professionali e artigiani",
    localAreas: ["Centro", "San Maurizio al Lambro", "Cologno Nord"],
    nearCities: ["Milano", "Sesto San Giovanni", "Monza", "Brugherio"],
    localContext: "Centro economico importante dell'est milanese, sede di numerose aziende e attivita"
  },
  {
    id: "brugherio",
    name: "Brugherio",
    region: "Monza e Brianza",
    localBusinesses: "imprese locali, negozi, professionisti e attivita artigianali",
    localAreas: ["Centro", "San Damiano", "Baraggia", "Moncucco"],
    nearCities: ["Monza", "Milano", "Cologno Monzese", "Carugate"],
    localContext: "Comune della Brianza con forte tradizione imprenditoriale e commerciale"
  },
  {
    id: "carugate",
    name: "Carugate",
    region: "Milano",
    localBusinesses: "centri commerciali, negozi, PMI e professionisti",
    localAreas: ["Centro", "Cascina Garibaldi", "Via Milano"],
    nearCities: ["Cologno Monzese", "Brugherio", "Agrate Brianza", "Cernusco sul Naviglio"],
    localContext: "Comune dinamico dell'est milanese, noto per il centro commerciale e le attivita locali"
  },
  {
    id: "cernusco-sul-naviglio",
    name: "Cernusco sul Naviglio",
    region: "Milano",
    localBusinesses: "studi professionali, negozi, ristoranti e piccole imprese",
    localAreas: ["Centro Storico", "Ronco", "Naviglio Martesana"],
    nearCities: ["Milano", "Cologno Monzese", "Carugate", "Pioltello"],
    localContext: "Elegante cittadina sul Naviglio Martesana con un centro storico vivace e attivita fiorenti"
  },
  {
    id: "paderno-dugnano",
    name: "Paderno Dugnano",
    region: "Milano",
    localBusinesses: "attivita commerciali, artigiani, professionisti e PMI",
    localAreas: ["Paderno", "Dugnano", "Palazzolo", "Cassina Amata"],
    nearCities: ["Milano", "Cusano Milanino", "Cormano", "Senago"],
    localContext: "Grande comune dell'area nord Milano con economia diversificata tra commercio e industria"
  },
  {
    id: "cusano-milanino",
    name: "Cusano Milanino",
    region: "Milano",
    localBusinesses: "negozi di quartiere, professionisti, piccole attivita e artigiani",
    localAreas: ["Cusano", "Milanino", "Via Sormani"],
    nearCities: ["Cinisello Balsamo", "Bresso", "Paderno Dugnano", "Cormano"],
    localContext: "Storica citta-giardino con atmosfera residenziale e attivita commerciali di vicinato"
  },
  {
    id: "cormano",
    name: "Cormano",
    region: "Milano",
    localBusinesses: "piccole imprese, attivita artigianali, negozi e studi professionali",
    localAreas: ["Cormano Centro", "Ospitaletto", "Brusuglio"],
    nearCities: ["Milano", "Bresso", "Cusano Milanino", "Paderno Dugnano"],
    localContext: "Comune alle porte di Milano con tessuto economico misto tra artigianato e servizi"
  },
  {
    id: "muggio",
    name: "Muggio",
    region: "Monza e Brianza",
    localBusinesses: "attivita commerciali, artigiani, professionisti e piccole aziende",
    localAreas: ["Centro", "Taccona", "Via Dante"],
    nearCities: ["Monza", "Nova Milanese", "Desio", "Cinisello Balsamo"],
    localContext: "Comune della Brianza con economia vivace basata su commercio e piccola impresa"
  },
  {
    id: "nova-milanese",
    name: "Nova Milanese",
    region: "Monza e Brianza",
    localBusinesses: "aziende del mobile, artigiani, negozi e studi professionali",
    localAreas: ["Centro", "Via Brodolini", "Zona Industriale"],
    nearCities: ["Monza", "Muggio", "Desio", "Paderno Dugnano"],
    localContext: "Importante centro del distretto del mobile brianzolo con tradizione manifatturiera"
  },
  {
    id: "monza",
    name: "Monza",
    region: "Monza e Brianza",
    localBusinesses: "aziende, negozi del centro, professionisti, ristoranti e attivita turistiche",
    localAreas: ["Centro Storico", "San Biagio", "San Rocco", "Cederna", "Triante"],
    nearCities: ["Milano", "Sesto San Giovanni", "Brugherio", "Muggio"],
    localContext: "Capoluogo di provincia con economia diversificata, dal commercio al turismo legato al Parco e all'Autodromo"
  },
  // Svizzera - Canton Ticino
  {
    id: "lugano",
    name: "Lugano",
    region: "Ticino",
    localBusinesses: "aziende, PMI, studi professionali, società di servizi e professionisti",
    localAreas: ["Centro", "Paradiso", "Cassarate", "Molino Nuovo", "Breganzona"],
    nearCities: ["Mendrisio", "Locarno", "Bellinzona", "Chiasso"],
    localContext: "Principale centro economico del Canton Ticino, con un tessuto imprenditoriale dinamico fatto di PMI, studi professionali, società di servizi e aziende internazionali"
  },
  {
    id: "locarno",
    name: "Locarno",
    region: "Ticino",
    localBusinesses: "attivita turistiche, hotel, ristoranti, negozi e professionisti",
    localAreas: ["Piazza Grande", "Muralto", "Minusio", "Solduno"],
    nearCities: ["Ascona", "Bellinzona", "Lugano", "Brissago"],
    localContext: "Rinomata destinazione turistica sul Lago Maggiore, nota per il Festival del Film e il clima mite"
  },
  {
    id: "mendrisio",
    name: "Mendrisio",
    region: "Ticino",
    localBusinesses: "aziende del distretto, professionisti, negozi e attivita enogastronomiche",
    localAreas: ["Centro Storico", "Rancate", "Genestrerio", "Ligornetto"],
    nearCities: ["Lugano", "Como", "Chiasso", "Varese"],
    localContext: "Centro del Mendrisiotto, distretto industriale e vinicolo con forte legame transfrontaliero"
  }
];

// Generate all SEO routes
export const generateSeoRoutes = () => {
  const routes = [];
  
  seoCities.forEach(city => {
    seoServices.forEach(service => {
      const slug = `${service.id}-${city.id}`;
      routes.push({
        path: `/${slug}`,
        city: city.name,
        cityId: city.id,
        region: city.region,
        service: service.name,
        serviceId: service.id,
        metaTitle: service.metaTitleTemplate.replace("{city}", city.name),
        metaDescription: service.metaDescTemplate.replace("{city}", city.name),
        heroTitle: service.heroTitle,
        heroHighlight: service.heroHighlight,
        heroSubtitle: service.heroSubtitle,
        localBusinesses: city.localBusinesses,
        localAreas: city.localAreas,
        nearCities: city.nearCities,
        localContext: city.localContext
      });
    });
  });
  
  return routes;
};

// ============================================
// PROFESSIONI - Landing Pages per Settore
// ============================================

export const seoProfessions = [
  // Studi Professionali
  {
    id: "avvocati",
    name: "Avvocati",
    category: "Studi Professionali",
    heroTitle: "Siti web per Avvocati a",
    heroHighlight: "che portano nuovi clienti",
    heroSubtitle: "Presenza online professionale per studi legali. Siti che comunicano competenza, affidabilita e generano contatti qualificati.",
    metaTitleTemplate: "Siti Web per Avvocati {city} | Studio Legale Online",
    metaDescTemplate: "Realizziamo siti web per avvocati e studi legali a {city}. Design professionale, SEO locale, generazione contatti. Preventivo gratuito.",
    targetDescription: "studi legali, avvocati civilisti, penalisti, tributaristi e professionisti del diritto",
    painPoints: [
      "I potenziali clienti non ti trovano quando cercano un avvocato online",
      "Il tuo sito attuale non trasmette la professionalita del tuo studio",
      "Non ricevi richieste di consulenza dal web",
      "I competitor hanno una presenza online piu forte"
    ],
    benefits: [
      "Sito che comunica autorevolezza e competenza legale",
      "Ottimizzazione per ricerche tipo 'avvocato + citta'",
      "Form di contatto per richieste di consulenza",
      "Sezioni dedicate alle aree di specializzazione"
    ],
    services: ["Diritto civile", "Diritto penale", "Diritto del lavoro", "Diritto tributario", "Diritto societario"]
  },
  {
    id: "commercialisti",
    name: "Commercialisti",
    category: "Studi Professionali",
    heroTitle: "Siti web per Commercialisti a",
    heroHighlight: "che acquisiscono clienti",
    heroSubtitle: "Siti professionali per studi di commercialisti. Comunica competenza fiscale e attira nuovi clienti aziendali e privati.",
    metaTitleTemplate: "Siti Web per Commercialisti {city} | Studio Commerciale Online",
    metaDescTemplate: "Creiamo siti web per commercialisti a {city}. Presenza professionale, SEO locale, acquisizione clienti. Consulenza gratuita.",
    targetDescription: "studi commerciali, consulenti fiscali, revisori contabili e professionisti tributari",
    painPoints: [
      "Difficolta a trovare nuovi clienti oltre al passaparola",
      "Il sito non mostra chiaramente i servizi offerti",
      "Poca visibilita nelle ricerche locali",
      "Immagine online non all'altezza della professionalita"
    ],
    benefits: [
      "Presentazione chiara dei servizi fiscali e contabili",
      "SEO per ricerche 'commercialista + citta'",
      "Area dedicata alle scadenze e novita fiscali",
      "Moduli per richiesta preventivi e consulenze"
    ],
    services: ["Contabilita", "Dichiarazioni fiscali", "Consulenza aziendale", "Bilanci", "Revisione contabile"]
  },
  {
    id: "notai",
    name: "Notai",
    category: "Studi Professionali",
    heroTitle: "Siti web per Notai a",
    heroHighlight: "autorevoli e funzionali",
    heroSubtitle: "Presenza digitale istituzionale per studi notarili. Siti che comunicano affidabilita e facilitano il contatto con i clienti.",
    metaTitleTemplate: "Siti Web per Notai {city} | Studio Notarile Online",
    metaDescTemplate: "Siti web professionali per notai a {city}. Design istituzionale, informazioni chiare, prenotazione appuntamenti.",
    targetDescription: "studi notarili e professionisti del settore",
    painPoints: [
      "I clienti non trovano facilmente informazioni sui servizi",
      "Difficolta nella gestione degli appuntamenti",
      "Sito datato che non riflette la professionalita",
      "Mancanza di visibilita online rispetto ad altri studi"
    ],
    benefits: [
      "Design istituzionale e autorevole",
      "Sezioni informative su atti e procedure",
      "Sistema di prenotazione appuntamenti",
      "Ottimizzazione per ricerche locali"
    ],
    services: ["Atti immobiliari", "Successioni", "Societa", "Testamenti", "Procure"]
  },
  {
    id: "architetti",
    name: "Architetti",
    category: "Studi Professionali",
    heroTitle: "Siti web per Architetti a",
    heroHighlight: "che mostrano il tuo talento",
    heroSubtitle: "Portfolio digitali per studi di architettura. Siti che valorizzano i tuoi progetti e attirano nuovi committenti.",
    metaTitleTemplate: "Siti Web per Architetti {city} | Portfolio Architettura",
    metaDescTemplate: "Creiamo siti web per architetti a {city}. Portfolio progetti, design elegante, generazione contatti. Preventivo gratuito.",
    targetDescription: "studi di architettura, architetti liberi professionisti e designer d'interni",
    painPoints: [
      "I tuoi progetti meritano una vetrina migliore",
      "Difficolta a mostrare il portfolio in modo efficace",
      "Pochi contatti da potenziali committenti",
      "Il sito non riflette la tua creativita"
    ],
    benefits: [
      "Portfolio visivo ad alto impatto",
      "Gallerie progetti con filtri per tipologia",
      "Design che riflette il tuo stile",
      "SEO per ricerche 'architetto + citta'"
    ],
    services: ["Progettazione residenziale", "Ristrutturazioni", "Interior design", "Progettazione commerciale", "Rendering 3D"]
  },
  {
    id: "ingegneri",
    name: "Ingegneri",
    category: "Studi Professionali",
    heroTitle: "Siti web per Ingegneri a",
    heroHighlight: "che generano commesse",
    heroSubtitle: "Presenza online professionale per studi di ingegneria. Siti che comunicano competenza tecnica e attirano progetti.",
    metaTitleTemplate: "Siti Web per Ingegneri {city} | Studio Ingegneria Online",
    metaDescTemplate: "Siti web per ingegneri e studi tecnici a {city}. Presentazione servizi, portfolio progetti, acquisizione clienti.",
    targetDescription: "studi di ingegneria, ingegneri civili, strutturisti, impiantisti e consulenti tecnici",
    painPoints: [
      "Difficolta a comunicare le competenze tecniche online",
      "Poca visibilita per ricerche di settore",
      "Il sito non genera richieste di preventivo",
      "Mancanza di un portfolio progetti efficace"
    ],
    benefits: [
      "Presentazione chiara delle specializzazioni",
      "Portfolio progetti realizzati",
      "SEO per ricerche tecniche locali",
      "Form per richieste di consulenza"
    ],
    services: ["Progettazione strutturale", "Direzione lavori", "Perizie tecniche", "Certificazioni energetiche", "Consulenza sismica"]
  },
  // Medici e Professionisti Sanitari
  {
    id: "dentisti",
    name: "Dentisti",
    category: "Professionisti Sanitari",
    heroTitle: "Siti web per Dentisti a",
    heroHighlight: "che riempiono l'agenda",
    heroSubtitle: "Siti per studi dentistici che generano nuovi pazienti. Design rassicurante, prenotazione online, visibilita locale.",
    metaTitleTemplate: "Siti Web per Dentisti {city} | Studio Dentistico Online",
    metaDescTemplate: "Creiamo siti web per dentisti a {city}. Prenotazione online, SEO locale, acquisizione pazienti. Consulenza gratuita.",
    targetDescription: "studi dentistici, odontoiatri, ortodontisti e cliniche odontoiatriche",
    painPoints: [
      "L'agenda ha troppi buchi e pochi nuovi pazienti",
      "I pazienti non possono prenotare online",
      "Poca visibilita quando cercano 'dentista + citta'",
      "Il sito non trasmette fiducia e professionalita"
    ],
    benefits: [
      "Sistema di prenotazione appuntamenti online",
      "Design rassicurante che ispira fiducia",
      "SEO per ricerche 'dentista + citta'",
      "Presentazione trattamenti e tecnologie"
    ],
    services: ["Implantologia", "Ortodonzia", "Sbiancamento", "Igiene dentale", "Protesi"]
  },
  {
    id: "fisioterapisti",
    name: "Fisioterapisti",
    category: "Professionisti Sanitari",
    heroTitle: "Siti web per Fisioterapisti a",
    heroHighlight: "che acquisiscono pazienti",
    heroSubtitle: "Presenza online per studi di fisioterapia. Siti che comunicano competenza e facilitano la prenotazione.",
    metaTitleTemplate: "Siti Web per Fisioterapisti {city} | Studio Fisioterapia Online",
    metaDescTemplate: "Siti web per fisioterapisti a {city}. Prenotazione trattamenti, SEO locale, acquisizione pazienti. Preventivo gratuito.",
    targetDescription: "studi di fisioterapia, fisioterapisti, centri riabilitazione e professionisti del benessere",
    painPoints: [
      "Difficolta a farsi trovare dai pazienti online",
      "Gestione appuntamenti ancora telefonica",
      "Il sito non spiega bene i trattamenti offerti",
      "Poca differenziazione dai competitor"
    ],
    benefits: [
      "Prenotazione online dei trattamenti",
      "Descrizione chiara delle terapie",
      "SEO per ricerche sanitarie locali",
      "Sezione FAQ per i pazienti"
    ],
    services: ["Riabilitazione ortopedica", "Terapia manuale", "Massoterapia", "Rieducazione posturale", "Terapie strumentali"]
  },
  {
    id: "psicologi",
    name: "Psicologi",
    category: "Professionisti Sanitari",
    heroTitle: "Siti web per Psicologi a",
    heroHighlight: "che ispirano fiducia",
    heroSubtitle: "Siti per psicologi e psicoterapeuti. Design accogliente che comunica empatia e professionalita.",
    metaTitleTemplate: "Siti Web per Psicologi {city} | Studio Psicologia Online",
    metaDescTemplate: "Creiamo siti web per psicologi a {city}. Design empatico, prenotazione consulti, visibilita locale. Consulenza gratuita.",
    targetDescription: "psicologi, psicoterapeuti, neuropsicologi e counselor",
    painPoints: [
      "I pazienti faticano a fare il primo passo per contattarti",
      "Il sito non trasmette l'accoglienza del tuo approccio",
      "Poca visibilita per chi cerca supporto psicologico",
      "Difficolta a comunicare le aree di specializzazione"
    ],
    benefits: [
      "Design accogliente e rassicurante",
      "Presentazione empatica dei servizi",
      "Form di contatto discreto e professionale",
      "SEO per ricerche 'psicologo + citta'"
    ],
    services: ["Psicoterapia individuale", "Terapia di coppia", "Psicologia infantile", "Gestione ansia e stress", "Supporto al lutto"]
  },
  {
    id: "nutrizionisti",
    name: "Nutrizionisti",
    category: "Professionisti Sanitari",
    heroTitle: "Siti web per Nutrizionisti a",
    heroHighlight: "che attraggono clienti",
    heroSubtitle: "Presenza online per nutrizionisti e dietologi. Siti che comunicano competenza e generano richieste di consulenza.",
    metaTitleTemplate: "Siti Web per Nutrizionisti {city} | Studio Nutrizione Online",
    metaDescTemplate: "Siti web per nutrizionisti a {city}. Presentazione servizi, prenotazione consulti, SEO locale. Preventivo gratuito.",
    targetDescription: "nutrizionisti, dietologi, dietisti e professionisti dell'alimentazione",
    painPoints: [
      "Difficolta a distinguersi nel mercato del benessere",
      "Il sito non converte visitatori in pazienti",
      "Poca visibilita per ricerche locali",
      "Mancanza di un sistema di prenotazione efficace"
    ],
    benefits: [
      "Presentazione professionale dei servizi",
      "Sezione dedicata all'approccio nutrizionale",
      "Prenotazione consulenze online",
      "Blog per contenuti SEO"
    ],
    services: ["Piani alimentari personalizzati", "Nutrizione sportiva", "Dimagrimento", "Intolleranze alimentari", "Educazione alimentare"]
  },
  // Attivita Locali
  {
    id: "agenzie-immobiliari",
    name: "Agenzie Immobiliari",
    category: "Attivita Locali",
    heroTitle: "Siti web per Agenzie Immobiliari a",
    heroHighlight: "che vendono di piu",
    heroSubtitle: "Siti per agenzie immobiliari che generano contatti. Vetrina immobili, ricerca avanzata, acquisizione clienti.",
    metaTitleTemplate: "Siti Web per Agenzie Immobiliari {city} | Immobiliare Online",
    metaDescTemplate: "Creiamo siti web per agenzie immobiliari a {city}. Vetrina immobili, SEO locale, generazione lead. Preventivo gratuito.",
    targetDescription: "agenzie immobiliari, agenti immobiliari e property manager",
    painPoints: [
      "Gli annunci sui portali non bastano piu",
      "Difficolta a differenziarsi dalla concorrenza",
      "Il sito non genera richieste dirette",
      "Mancanza di una vetrina immobili efficace"
    ],
    benefits: [
      "Catalogo immobili con ricerca avanzata",
      "Schede immobile ottimizzate SEO",
      "Form di contatto per ogni annuncio",
      "Integrazione con portali immobiliari"
    ],
    services: ["Vendita immobili", "Affitti", "Valutazioni", "Gestione patrimoni", "Consulenza immobiliare"]
  },
  {
    id: "elettricisti",
    name: "Elettricisti",
    category: "Attivita Locali",
    heroTitle: "Siti web per Elettricisti a",
    heroHighlight: "che portano lavoro",
    heroSubtitle: "Presenza online per elettricisti e imprese elettriche. Siti che generano richieste di preventivo e interventi.",
    metaTitleTemplate: "Siti Web per Elettricisti {city} | Impresa Elettrica Online",
    metaDescTemplate: "Siti web per elettricisti a {city}. Visibilita locale, richieste preventivo, acquisizione clienti. Consulenza gratuita.",
    targetDescription: "elettricisti, imprese elettriche, installatori e manutentori",
    painPoints: [
      "I clienti non ti trovano quando cercano un elettricista",
      "Troppa dipendenza dal passaparola",
      "Difficolta a mostrare i lavori realizzati",
      "Nessun sistema per richieste di preventivo"
    ],
    benefits: [
      "SEO per ricerche 'elettricista + citta'",
      "Gallery lavori realizzati",
      "Form richiesta preventivo rapido",
      "Pagina servizi dettagliata"
    ],
    services: ["Impianti elettrici", "Manutenzione", "Domotica", "Certificazioni", "Pronto intervento"]
  },
  {
    id: "idraulici",
    name: "Idraulici",
    category: "Attivita Locali",
    heroTitle: "Siti web per Idraulici a",
    heroHighlight: "che generano chiamate",
    heroSubtitle: "Siti per idraulici che portano lavoro. Visibilita locale, richieste di intervento, pronto soccorso idraulico.",
    metaTitleTemplate: "Siti Web per Idraulici {city} | Idraulico Online",
    metaDescTemplate: "Siti web per idraulici a {city}. Pronto intervento, SEO locale, acquisizione clienti. Preventivo gratuito.",
    targetDescription: "idraulici, imprese idrauliche, termoidraulici e manutentori",
    painPoints: [
      "I clienti cercano 'idraulico urgente' ma non ti trovano",
      "Il passaparola non basta piu",
      "Nessuna presenza online professionale",
      "Difficolta a gestire richieste di intervento"
    ],
    benefits: [
      "SEO per emergenze idrauliche locali",
      "Numero di telefono ben visibile",
      "Form richiesta intervento rapido",
      "Pagina pronto intervento 24h"
    ],
    services: ["Riparazioni", "Installazioni", "Manutenzione caldaie", "Pronto intervento", "Ristrutturazioni bagni"]
  },
  {
    id: "imprese-pulizia",
    name: "Imprese di Pulizia",
    category: "Attivita Locali",
    heroTitle: "Siti web per Imprese di Pulizia a",
    heroHighlight: "che acquisiscono contratti",
    heroSubtitle: "Presenza online per imprese di pulizia. Siti che generano richieste di preventivo da aziende e privati.",
    metaTitleTemplate: "Siti Web per Imprese di Pulizia {city} | Pulizie Professionali",
    metaDescTemplate: "Siti web per imprese di pulizia a {city}. Acquisizione clienti, preventivi online, visibilita locale. Consulenza gratuita.",
    targetDescription: "imprese di pulizia, servizi di sanificazione e facility management",
    painPoints: [
      "Difficolta a trovare nuovi clienti aziendali",
      "Il sito non genera richieste di preventivo",
      "Poca visibilita per gare e appalti",
      "Mancanza di un portfolio clienti online"
    ],
    benefits: [
      "Presentazione servizi per target diversi",
      "Form preventivo con specifiche",
      "Sezione clienti e referenze",
      "SEO per ricerche B2B e B2C"
    ],
    services: ["Pulizie uffici", "Pulizie condomini", "Sanificazione", "Pulizie industriali", "Vetri e facciate"]
  }
];

// Generate profession routes for a specific city
export const generateProfessionRoutes = () => {
  const routes = [];
  
  seoCities.forEach(city => {
    seoProfessions.forEach(profession => {
      const slug = `siti-web-${profession.id}-${city.id}`;
      routes.push({
        path: `/${slug}`,
        city: city.name,
        cityId: city.id,
        region: city.region,
        profession: profession.name,
        professionId: profession.id,
        category: profession.category,
        metaTitle: profession.metaTitleTemplate.replace("{city}", city.name),
        metaDescription: profession.metaDescTemplate.replace("{city}", city.name),
        heroTitle: profession.heroTitle,
        heroHighlight: profession.heroHighlight,
        heroSubtitle: profession.heroSubtitle,
        targetDescription: profession.targetDescription,
        painPoints: profession.painPoints,
        benefits: profession.benefits,
        professionServices: profession.services,
        localAreas: city.localAreas,
        nearCities: city.nearCities,
        localContext: city.localContext
      });
    });
  });
  
  return routes;
};

// Get all routes for sitemap generation
export const getAllSeoUrls = () => {
  const serviceRoutes = generateSeoRoutes().map(route => route.path);
  const professionRoutes = generateProfessionRoutes().map(route => route.path);
  return [...serviceRoutes, ...professionRoutes];
};

// Analytics data - zeroed for deploy
// In production, connect to real analytics API (Google Analytics, etc.)
export const generateMockAnalytics = (routes) => {
  const analytics = {};
  
  routes.forEach(route => {
    analytics[route.path] = {
      views: 0,
      conversions: 0,
      conversionRate: 0,
      trend: 'stable'
    };
  });
  
  return analytics;
};

// Stats for admin dashboard
export const getSeoStats = () => {
  const serviceRoutes = generateSeoRoutes();
  const professionRoutes = generateProfessionRoutes();
  const allRoutes = [...serviceRoutes, ...professionRoutes];
  
  const citiesCount = seoCities.length;
  const servicesCount = seoServices.length;
  const professionsCount = seoProfessions.length;
  const totalServicePages = serviceRoutes.length;
  const totalProfessionPages = professionRoutes.length;
  const totalPages = allRoutes.length;
  
  const byRegion = seoCities.reduce((acc, city) => {
    acc[city.region] = (acc[city.region] || 0) + servicesCount + professionsCount;
    return acc;
  }, {});
  
  const byCategory = seoProfessions.reduce((acc, prof) => {
    acc[prof.category] = (acc[prof.category] || 0) + 1;
    return acc;
  }, {});
  
  // Generate mock analytics
  const analytics = generateMockAnalytics(allRoutes);
  
  // Calculate totals
  const totalViews = Object.values(analytics).reduce((sum, a) => sum + a.views, 0);
  const totalConversions = Object.values(analytics).reduce((sum, a) => sum + a.conversions, 0);
  const avgConversionRate = totalViews > 0 ? (totalConversions / totalViews * 100).toFixed(1) : '0.0';
  
  return {
    totalPages,
    totalServicePages,
    totalProfessionPages,
    citiesCount,
    servicesCount,
    professionsCount,
    byRegion,
    byCategory,
    routes: serviceRoutes,
    professionRoutes,
    analytics,
    totalViews,
    totalConversions,
    avgConversionRate
  };
};
